export const messages = {
  contactDetails: {
    edit: {
      id: 'contactDetails.Edit',
      defaultMessage: 'Edit',
    },
    moreLink: {
      id: 'contactDetails.Link.More',
      defaultMessage: 'More...',
    },
    popOverTitle: {
      id: 'contactDetails.PopOverTitle',
      defaultMessage: 'Contact Details',
    },
    changeButton: {
      id: 'contactDetails.Button.Change',
      defaultMessage: 'Change',
    },
    authorizedMessage: {
      id: 'contactDetails.Message.Authorized',
      defaultMessage: 'Authorized to access my record.',
    },
    notAuthorizedMessage: {
      id: 'contactDetails.Message.NotAuthorized',
      defaultMessage: 'Not authorized to access my record.',
    },
    pendingAuthorizedMessage: {
      id: 'contactDetails.Message.PendingAuthorized',
      defaultMessage: 'Access to my record is pending.',
    },
    primaryContact: {
      id: 'contactDetails.PrimaryContact',
      defaultMessage: 'Primary Contact',
    },
  },
};
